var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group"},_vm._l((_vm.group),function(btn,i){return _c('div',{key:`bg_${i}`,staticClass:"item",class:btn.selected&&'selected',on:{"click":function($event){return _vm.$emit('change',i,_vm.name)}}},[_c('span',{domProps:{"textContent":_vm._s(btn.name)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }